exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root .MuiAutocomplete-popper {\n  z-index: 99999 !important;\n}", ""]);
